import { parseAsBoolean } from "nuqs";

import { usePersistedQueryStates } from "@/src/hooks/use-persisted-query-states";

export const taskFilterQueryParams = {
  showCompleted: parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: false }),
  filterOutsideSla: parseAsBoolean.withDefault(false).withOptions({ clearOnDefault: true }),
};

export function useTaskFilters() {
  return usePersistedQueryStates(taskFilterQueryParams);
}

export type TaskFilters = ReturnType<typeof useTaskFilters>[0];
